<template>
  <div class="background"
    style="height: 607px;"
  >
    <v-carousel 
      v-model="selectedCarouselItem"
      :cycle="false"
      :show-arrows="false" 
      hide-delimiters
      height="607"
    >
      <!--v-carousel-item
        v-for="(item,i) in images"
        :key="i"
        :src="item"
      /-->
      <v-carousel-item
        v-for="(item, i) in contents"
        :key="i"
        v-html="item.content"
      />
    </v-carousel>
  </div>
</template>
<script>
import axios from 'axios'
import { parseString } from 'xml2js'
export default {
  props: {
    parrilla: {
      type: String,
      default: `https://www.dviewcontent.com/image/result/06_8f01ee10-1fdb-11ec-b877-1dbb98d39c7b.xml`,
    },
  },
  data: () => ({
    images: null,
    contents: null,
    selectedCarouselItem: null,
    timer: null,
  }),
  watch: {
    parrilla (v) {
      this.getImages()
    },
  },
  mounted () {
    this.prepareTimer()
    this.getImages ()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    prepareTimer () {
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        //console.log('T ----')
        this.getImages()
      }, 900000)
      //}, 1000)
    },
    prepareMediaContent (type, url, duration) {
      if (!duration || duration.length === 0) duration = 1
      const content = type === 'mp4' ? `<video src="${url}" width="100%" height="607px" loop
            autoplay="autoplay" muted defaultmuted playsinline />`
        : `<img src="${url}" width="100%" height="607px">`
      return {
        content,
        duration,
        type
      }
        //return `<v-img src="${url}" height="607px" width="100%" />`
    },
    handleIntervalImage () {
      const content = this.contents[this.selectedCarouselItem]
      const duration = content ? content.duration * 1000 : 0
      //if (this.contents[this.selectedCarouselItem].type === 'mp4') return
      setTimeout(() => {
        this.handleChangeContent()
      }, duration)
    },
    handleChangeContent () {
      this.selectedCarouselItem = this.selectedCarouselItem < this.contents.length-1 ? this.selectedCarouselItem + 1 : 0
      this.handleIntervalImage () 
    },
    async convertXML (v) {
      const that = this
      try {
        return await new Promise((resolve, reject) => parseString(v, (err, results) => {
          if (err) reject(err)
          else {
            resolve(results.rss.channel.shift().item.map(item => {
              const { url, type, duration } = item['media:content'].shift()['$']
              return that.prepareMediaContent(type, url, duration)
            }))
          }
        })) 
      } catch (error) {
        console.log(error)
        return []
      }
    },
    async getImages () {
      try {
        //this.contents = []
        const urls = this.parrilla.split(';')
        const contents = []
        for (const url of urls) {
          if (url.toLowerCase().includes('.xml')) {
            contents.push(...await new Promise((resolve, reject) => axios.get(url)
              .then (response => {
                if (response && response.data) resolve(this.convertXML(response.data))
              })
              .catch (err => {
                reject(err)
              })
            ))
          } else {
            const item = {
              type: 'html',
              duration: 300
            }
            const aux = url.toLowerCase().split('http')
            if (aux.length > 0 && aux[0] && aux[0].length > 0) {
              item.duration = parseInt(aux[0])
              item.content = `<iframe src="${url.split(aux[0]).join('')}" frameborder="0" style="width: 1920px; height: 1080px; transform: scale(0.562037); transform-origin: 0px 0px 0px;" />`
            } else {
              item.content = `<iframe src="${url}" frameborder="0" style="width: 1920px; height: 1080px; transform: scale(0.562037); transform-origin: 0px 0px 0px;" />`
            }
            contents.push(item)
          }
        }

        if (!this.contents || this.contents.map(item => item.content).join(',') !== contents.map(item => item.content).join(',')) {
          this.contents = []
          this.contents = contents
          //console.log(contents)
          if (this.contents.length === 0 ) return
          this.selectedCarouselItem = 0
          this.handleIntervalImage()
        }
      } catch (error) {
        console.log(error)
      }
      /*this.contents = [
        `<iframe width="560" height="315" src="https://www.youtube.com/embed/zjcVPZCG4sM" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`,
        `<video id="VideoPlayer" src="https://www.dviewcontent.com/asset/9f794be0-d81c-11e7-8bbc-bfcffb4c8a70/7321fc00-dadf-11e9-8ed6-33d7c5ea1d5a.mp4" width="100%" height="607px"
            controls="true" autoplay="autoplay" loop="true" muted defaultmuted playsinline />`,
        `<iframe width="560" height="315" src="https://www.youtube.com/embed/zjcVPZCG4sM" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`,
      ]*/
      /*
      axios.get(this.parrilla)// && this.enterpariseTotemBackground !== undefined ? this.enterpriseTotemBackground : `https://www.dviewcontent.com/image/result/06_8f01ee10-1fdb-11ec-b877-1dbb98d39c7b.xml`)
        .then (response => {
          try {
            const that = this
            parseString (response.data, (err, results) => {
            // parsing to json
              that.contents = []
              that.contents = results.rss.channel.shift().item.map(item => {
                const { url, type, duration } = item['media:content'].shift()['$']
                return that.prepareMediaContent(type, url, duration)
              })//.filter(x => x.indexOf('.mp4') === -1)
              if (that.contents.length === 0 ) return
              that.selectedCarouselItem = 0
              this.handleIntervalImage()
            })
          } catch (error) {
           console.log(error)
          }
        })*/
    },
  }
}
</script>
<style scoped>
.background {
  position: relative;
  height: 100%;
}
</style>

